"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  select: {
    alignItems: "center",
    columnGap: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between"
  },
  label: {
    fontWeight: theme.typography.fontWeightBold
  },
  icon: {
    display: "none",
    marginLeft: "auto",
    "& svg": {
      height: 28,
      width: "auto !important"
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex"
    }
  }
}));
var _default = exports.default = styles;